import EntitySearchInput from "components/form/EntitySearch/EntitySearchInput";
import FormRow from "components/form/FormRow";
import { useFieldValue } from "components/form/input/NestedField";
import TextInput from "components/form/input/TextInput";
import ApontamentoAmostraParams, {
    useTipoApontamento,
} from "entity/Indicador/components/apontamento/fields/ApontamentoAmostraParams";
import ApontamentoClienteParams, {
    ApontamentoParamItem,
} from "entity/Indicador/components/apontamento/fields/ApontamentoClienteParams";
import ApontamentoColetas from "entity/Indicador/components/apontamento/fields/ApontamentoColetas";
import ApontamentoCommonFields from "entity/Indicador/components/apontamento/fields/ApontamentoCommonFields";
import ApontamentoImages from "entity/Indicador/components/apontamento/fields/ApontamentoImages";
import ApontamentoObservacao from "entity/Indicador/components/apontamento/fields/ApontamentoObservacao";
import ApontamentoResultado from "entity/Indicador/components/apontamento/fields/ApontamentoResultado";
import Insumo from "entity/Insumo";
import { useEffect } from "react";
import { useForm } from "react-final-form";
import { numberToPtBrLocaleString } from "util/number";
import Operador from "entity/Operador";
import AC from "..";

export default function ACEditFields({ visita, TipoClass }) {
    const [tipo, setTipo] = useTipoApontamento();
    const params = visita.cliente.getParams(AC, "Mecanizado", TipoClass);

    const [apontamento] = useFieldValue();
    const [quantColetas] = useFieldValue("quantidadeColetas");
    const form = useForm();

    useEffect(() => {
        if (tipo !== "Mecanizado") {
            setTipo("Mecanizado");
        }
    }, [setTipo, tipo]);

    useEffect(() => {
        if (apontamento) {
            apontamento.conformidade = AC.calcConformidade(apontamento, params);
            apontamento.quantColetas = quantColetas;
            form.change("conformidade", AC.calcConformidade(apontamento, params));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [apontamento, params]);

    return (
        <>
            <ApontamentoCommonFields visita={visita} TipoClass={TipoClass} showVariedade />

            <ApontamentoAmostraParams tipoFixedValue={"Mecanizado"}>
                <FormRow>
                    <EntitySearchInput name="insumo" label="Insumo" EntityClass={Insumo} required />
                </FormRow>
                <FormRow>
                    <TextInput type="number" name="dosagemRecomendada" label="Dosagem Recomendada" required />
                </FormRow>
                <FormRow>
                    <TextInput type="number" name="qtdBandejas" label="Quantidade de bandejas" required />
                </FormRow>
                <FormRow>
                    <EntitySearchInput
                        name="operador"
                        label="Operador"
                        EntityClass={Operador}
                        extraQuery={(query) => query.where("cliente.uid", "==", visita.data.cliente.uid)}
                    />
                </FormRow>
            </ApontamentoAmostraParams>

            <ApontamentoClienteParams params={params}>
                {params ? (
                    <>
                        <ApontamentoParamItem label="Intervalo:">
                            ({params.intervaloMin}, {params.intervaloMax})
                        </ApontamentoParamItem>
                        <ApontamentoParamItem label="Meta (%):">
                            {parseFloat(params.meta).toFixed(2)}
                        </ApontamentoParamItem>
                        <ApontamentoParamItem label="Área (ha)">
                            {numberToPtBrLocaleString(params.areaHa)}
                        </ApontamentoParamItem>
                        <ApontamentoParamItem label="Largura">
                            {parseFloat(params.largura).toFixed(2)}
                        </ApontamentoParamItem>
                        <ApontamentoParamItem label="Comprimento">
                            {parseFloat(params.comprimento).toFixed(2)}
                        </ApontamentoParamItem>
                    </>
                ) : null}
            </ApontamentoClienteParams>

            <FormRow>
                <TextInput
                    error={Number(quantColetas) < 2 || Number(quantColetas) > 4}
                    helperText="Insira um valor entre 2 e 4"
                    type="number"
                    name="quantidadeColetas"
                    label="Quantidade de Coletas"
                    required
                />
            </FormRow>
            <ApontamentoColetas visita={visita}>
                {quantColetas === "2" && (
                    <>
                        <FormRow>
                            <TextInput type="number" name="coleta1" label="Coleta 1" />
                            <TextInput name="conformeCol1" label="Conforme Coleta 1" disabled />
                        </FormRow>

                        <FormRow>
                            <TextInput type="number" name="coleta2" label="Coleta 2" />
                            <TextInput name="conformeCol2" label="Conforme Coleta 2" disabled />
                        </FormRow>
                    </>
                )}

                {quantColetas === "3" && (
                    <>
                        <FormRow>
                            <TextInput type="number" name="coleta1" label="Coleta 1" />
                            <TextInput name="conformeCol1" label="Conforme Coleta 1" disabled />
                        </FormRow>

                        <FormRow>
                            <TextInput type="number" name="coleta2" label="Coleta 2" />
                            <TextInput name="conformeCol2" label="Conforme Coleta 2" disabled />
                        </FormRow>

                        <FormRow>
                            <TextInput type="number" name="coleta3" label="Coleta 3" />
                            <TextInput name="conformeCol3" label="Conforme Coleta 3" disabled />
                        </FormRow>
                    </>
                )}

                {quantColetas === "4" && (
                    <>
                        <FormRow>
                            <TextInput type="number" name="coleta1" label="Coleta 1" />
                            <TextInput name="conformeCol1" label="Conforme Coleta 1" disabled />
                        </FormRow>

                        <FormRow>
                            <TextInput type="number" name="coleta2" label="Coleta 2" />
                            <TextInput name="conformeCol2" label="Conforme Coleta 2" disabled />
                        </FormRow>

                        <FormRow>
                            <TextInput type="number" name="coleta3" label="Coleta 3" />
                            <TextInput name="conformeCol3" label="Conforme Coleta 3" disabled />
                        </FormRow>

                        <FormRow>
                            <TextInput type="number" name="coleta4" label="Coleta 4" />
                            <TextInput name="conformeCol4" label="Conforme Coleta 4" disabled />
                        </FormRow>
                    </>
                )}

                {/* ) */}
            </ApontamentoColetas>

            <ApontamentoResultado />
            <ApontamentoObservacao />
            <ApontamentoImages visita={visita} />
        </>
    );
}
